import React, { memo } from 'react'

import { Images } from 'APP/Themes'

import { usePostContext } from 'APP/Lib/Context'
import Analytics from 'APP/Services/Analytics'
import Card from 'APP/Components/Chat/Card'
import { navigation } from 'APP/Nav/NestedNavHelper'

const SelfNavigation: React.FC = () => {
  const { post } = usePostContext()

  const searchTerm: string | undefined = post?.props?.searchterm
  const title: string = post?.message || ''

  const onPress = (): void => {
    navigation.navigate('selfNavigation', {
      specialtyKey: searchTerm,
    })

    Analytics.trackEvent('button_click', {
      button_value: 'Open Self-Navigation Screen',
    })
  }

  return (
    <Card
      title={title}
      iconSrc={Images.selfNavigation}
      onPress={onPress}
      testID="SELF_NAVIGATION_CARD"
    />
  )
}

export default memo(SelfNavigation)
